export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('ow-stores');

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('ow-stores', serializedState);
  } catch (err) {
    // die
  }
};



// WEBPACK FOOTER //
// ./src/store/localStorage.js